export default __webpack_public_path__ + "static/media/BI.94dc6ac4.svg";